import type { Agent } from '../agents/registry.ts';
import './AgentMeta.css';

interface AgentMetaProps {
  agent: Agent;
}

/**
 * One agent's role/name/blurb block in the hero meta stack. All blocks are
 * rendered into the same stacked container; the parent's `data-active-agent`
 * attribute decides which one is opaque. The ENGAGE link lives in the
 * sibling `.om-hero__action` slot so it can sit directly under the octagon
 * on mobile.
 */
export default function AgentMeta({ agent }: AgentMetaProps) {
  return (
    <div className={`om-agent-meta om-agent-meta--${agent.slug}`}>
      <p className="om-agent-meta__role">
        {agent.agentNumber} · {agent.role}
      </p>
      <h2 className="om-agent-meta__name">{agent.name}</h2>
      <p className="om-agent-meta__blurb">{agent.blurb}</p>
      {/* Jump link only for AVAILABLE agents — mirrors the Hero caps-section
          gate, so an in-training agent never links to a section that isn't
          rendered. */}
      {agent.capabilities?.length ? (
        <a
          href="#agent-caps"
          className="om-agent-meta__caps-jump"
          onClick={(e) => {
            e.preventDefault();
            document
              .getElementById('agent-caps')
              ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
        >
          ↓ What {agent.name} can do
        </a>
      ) : null}
    </div>
  );
}
